import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';
import * as style from './style.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PlanNotAvailable = function PlanNotAvailable(_ref) {
  var _ref$isFloorPlanNotAv = _ref.isFloorPlanNotAvailable,
    isFloorPlanNotAvailable = _ref$isFloorPlanNotAv === void 0 ? false : _ref$isFloorPlanNotAv;
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    "data-testid": "PlanNotAvailable",
    children: [/*#__PURE__*/_jsx("div", {
      className: style['logo']
    }), /*#__PURE__*/_jsx("div", {
      className: style['description'],
      children: /*#__PURE__*/_jsxs(UIHeading2, {
        textAlign: "center",
        children: ["\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u043C\u044B \u043D\u0435 \u0437\u043D\u0430\u0435\u043C ", /*#__PURE__*/_jsx("br", {}), " \u0442\u043E\u0447\u043D\u043E\u0433\u043E \u043F\u043B\u0430\u043D\u0430 ", isFloorPlanNotAvailable ? 'квартиры' : 'этажа']
      })
    })]
  });
};